export var ApiKeyCapability;
(function (ApiKeyCapability) {
    ApiKeyCapability["PATIENT_CREATION"] = "PATIENT_CREATION";
    ApiKeyCapability["PATIENT_DELETION"] = "PATIENT_DELETION";
})(ApiKeyCapability || (ApiKeyCapability = {}));
//# sourceMappingURL=api-key-capability.enum.js.map